var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "drop-shadow afterSave", attrs: { "max-width": "400" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
          _c("w-spacer"),
          _c("w-fa", {
            staticClass: "close-button",
            attrs: { icon: "times", right: "" },
            on: {
              click: function ($event) {
                return _vm.cancel()
              },
            },
          }),
        ],
        1
      ),
      _vm.isAllowed()
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c("w-input", {
                    ref: "input",
                    style: { flexGrow: 1, marginRight: "5px" },
                    attrs: { value: _vm.link },
                    nativeOn: {
                      click: function ($event) {
                        return $event.target.select()
                      },
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("tooltip.copy-to-clipboard"),
                          expression: "$ct('tooltip.copy-to-clipboard')",
                        },
                      ],
                      staticClass: "mls",
                      on: {
                        click: function ($event) {
                          return _vm.copyLink()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "copy" } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("tooltip.go"),
                          expression: "$ct('tooltip.go')",
                        },
                      ],
                      staticClass: "mls",
                      on: {
                        click: function ($event) {
                          return _vm.openLink()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "eye" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-card-content",
            [_c("app-missing-module", { attrs: { "module-id": 83 } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }